import styled, { css } from 'styled-components';

export const InputDomainWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin-top: 48px;
    width: 738px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: 100%;
    }
  `};
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 8px 0px 0px 0px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const FirstRow = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px 0px 32px;
`;

const textWrapperPadding = 23;
export const TextFieldWrapper = styled.form`
  ${({ theme }) => css`
    display: flex;
    padding: 0px ${textWrapperPadding}px 0px;
    position: relative;

    > div > div {
      padding-left: 67px;
      position: relative;

      &:before {
        color: ${theme.v2.colors.neutral.lowMedium};
        content:'www.';
        font-family: ${theme.v2.font.family.primary};
        font-size: ${theme.v2.font.sizes.xxs};
        font-weight: ${theme.v2.font.weights.regular};
        left: 16px;
        line-height: ${theme.v2.font.lineHeight.text};
        position: absolute;
        top: 20px;
      }
    }


    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0px;
    }
  `}
`;

export const AutoComplete = styled.ul`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 8px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    height: auto;
    margin: 0px;
    max-height: 140px;
    overflow-y: auto;
    padding: 0px;
    position: absolute;
    top: calc(100% + 8px);
    width: calc(100% - ${textWrapperPadding * 2}px);
    z-index: ${theme.v2.layers.important};

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.v2.colors.neutral.highPrimary};
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.v2.colors.neutral.highDark};
      border-radius: 25px;
      height: 30px;
      width: 8px;
    }
  `}
`;

export const AlertWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    margin: 32px 0px 0px;
    padding: 16px;

    > div:first-child {
      padding: 0px;

      svg {
        background-color: ${theme.v2.colors.neutral.highPure};
        border-radius: 100%;
        padding: 3px;
      }

      a {
        color: ${theme.v2.colors.brand.primaryBlue};
        font-size: ${theme.v2.font.sizes.xxs};
        font-weight: ${theme.v2.font.weights.regular};
        text-decoration-color: ${theme.v2.colors.brand.primaryBlue} !important;
      }

      span {
        color: ${theme.v2.colors.brand.primaryBlue};
        text-decoration: underline;
      }
    }
  `}
`;

export const ToggleWrapper = styled.div`
  display: flex;
  margin: 16px 0px 0px;
  max-width: 144px;
  width: 100%;
`;

export const ToggleContent = styled.p`
  ${({ toggled = false, theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    gap: 16px;
    line-height: ${theme.v2.font.lineHeight.text};
    margin: ${toggled ? '16px 0px' : '0px'};
    max-height: ${toggled ? '5000px' : '0px'};
    overflow: hidden;
    padding: 0px 0px 0px 24px;
    transition: 250ms ease-in-out;
  `}
`;

export const ActionsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    margin-top: 24px;
    gap: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column-reverse;
      margin-bottom: 120px;
    }
  `}
`;

export const AutoCompleteItem = styled.li`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    cursor: pointer;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.list};
    padding: 8px 16px;

    &:hover {
      background-color: ${theme.v2.colors.brand.primaryBlue};
      color: ${theme.v2.colors.neutral.highPure};
    }
  `}
`;
